import Vue from "vue";
export default {
  getRoles() {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/organization/system-settings/roles`)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
